import { render, staticRenderFns } from "./MlbbMatchStats.vue?vue&type=template&id=5f076a76&scoped=true"
import script from "./MlbbMatchStats.vue?vue&type=script&lang=js"
export * from "./MlbbMatchStats.vue?vue&type=script&lang=js"
import style0 from "./MlbbMatchStats.vue?vue&type=style&index=0&id=5f076a76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f076a76",
  null
  
)

export default component.exports